import { OrderDetailsUnauthenticated } from "../OrderDetailsUnauthenticated";
import { DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutTrackWithoutLoginDetailed extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelOrder: Label;
    labelOrderId: Label;
    layoutOrderDetailsUnauthenticated: OrderDetailsUnauthenticated;
    panelMain: Panel;
    sourceCustomerOrdersUnauthenticated: DataSource;
}
